import React from "react";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import Button from "./Button";
import Modal from "./Modal";
import { color } from "../../styles/theme";

/**
 * Generic explainer modal — web equivalent of the mobile app's
 * create-event-update/information-modal (title + body content + Okay button).
 */
const InfoModal = ({ title, children, onClose, closeLabel }) => {
  const { t } = useTranslation("common");
  return (
    <Modal title={title} onClose={onClose} maxWidth={440} footer={<Button onClick={onClose}>{closeLabel ?? t("actions.okay")}</Button>}>
      <div style={s.body}>{children}</div>
    </Modal>
  );
};

/** Small info trigger button meant to sit next to a field label. */
export const InfoButton = ({ onClick, label }) => {
  const { t } = useTranslation("common");
  const resolvedLabel = label ?? t("infoModal.moreInfo");
  return (
    <button type="button" onClick={onClick} style={s.infoBtn} aria-label={resolvedLabel} title={resolvedLabel}>
      <Info size={13} strokeWidth={2.25} />
    </button>
  );
};

const s = {
  body: { fontSize: 13.5, color: color.gray700, lineHeight: 1.6 },
  infoBtn: {
    display: "inline-flex", verticalAlign: "middle", background: "none", border: "none", color: color.primary500,
    cursor: "pointer", padding: 0, marginLeft: 6, lineHeight: 1,
  },
};

export default InfoModal;
